import apiClient from './client'

export const homeApi = {
  getHomeData: async () => {
    const response = await apiClient.get('/home')
    return response.data
  },
}

